import {
  ChipCategories,
  Constants,
  CoverageTypesCodes,
  LOB,
} from '../common/Constants';
import {
  CoverageType,
  Eligibility,
  MemberInfo,
} from '../common/PSXHeader/ObapiDemo/memberProfile';
import { dateFormatUTC } from '../common/Utils/datesUtils/formatDate';
import {
  convertDisplayNameToTitleCase,
  hasNonEmptyEligibilities,
} from './common';
import { getMemberHasDesignatedNetwork } from './user.utils';

export const getInitials = (name: string): string => {
  if (!name) {
    return '';
  }
  const [firstName, lastName] = name.split(' ');

  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  return firstName.charAt(0).toUpperCase();
};

export const getFirstName = (name: string): string => {
  if (!name) {
    return '';
  }
  const [firstName, lastName] = name.split(' ');

  if (firstName && lastName) {
    return firstName;
  }
  return firstName;
};

export const getFullName = (member: MemberInfo) => {
  const firstName = convertDisplayNameToTitleCase(
    member?.demographics?.name?.firstName
  );
  const lastName = convertDisplayNameToTitleCase(
    member?.demographics?.name?.lastName
  );
  return `${firstName} ${lastName}`;
};

export const getChipsByCoverages = (
  MOCK_CARE_CATEGORIES: {
    label: string;
    value: string;
    id: string;
    coverageType: string;
  }[],
  eligibility: Eligibility[] = [],
  currentMember,
  isVirtualCareSuppressedForEmpire,
  enableVirtualVisitChip,
  eligibilities,
  enableVirtualCareEpic
): { label: string; value: string; id: string; coverageType: string }[] => {
  const coverageTypeCodes: boolean[] = eligibility
    .flatMap((coverage) => coverage?.memberHealthCoverage?.coverageType)
    .map(
      (coverageType) =>
        (coverageType?.typeCode?.desc ===
          CoverageTypesCodes.BEHAVIORAL_HEALTH &&
          coverageType?.typeCode?.coverageTypeCode === 'B') ||
        (coverageType?.typeCode?.desc ===
          CoverageTypesCodes.BEHAVIORAL_CARVE_OUT &&
          coverageType?.typeCode?.coverageTypeCode === 'OBH')
    );

  if (coverageTypeCodes.includes(true))
    Constants.COVERAGE_TYPECODE_TO_CHIP.B =
      CoverageTypesCodes.BEHAVIORAL_HEALTH;
  else Constants.COVERAGE_TYPECODE_TO_CHIP.B = '';

  let showVirtualCareCard = false;

  if (enableVirtualCareEpic) {
    showVirtualCareCard =
      hasNonEmptyEligibilities(eligibilities) &&
      !isVirtualCareSuppressedForEmpire;
  } else {
    if (currentMember?.eligibility?.[0]?.memberHealthCoverage?.coverageType) {
      const coverageType: CoverageType | undefined =
        currentMember.eligibility[0]?.memberHealthCoverage?.coverageType?.find(
          (x: CoverageType) =>
            x.typeCode &&
            x.typeCode.desc === Constants.COVERAGE_TYPECODE_TO_CHIP.M
        );

      if (coverageType && coverageType.designatedNetwork) {
        showVirtualCareCard = getMemberHasDesignatedNetwork(
          coverageType,
          'DVCN'
        );
      }
    }

    showVirtualCareCard = currentMember?.isCnSMember
      ? !currentMember.isCnSDsnpMember && currentMember?.isTelemedicineEligible
      : showVirtualCareCard && !isVirtualCareSuppressedForEmpire;
  }

  const memberCoverage: string[] = eligibility
    .flatMap((coverage) => coverage?.memberHealthCoverage?.coverageType)
    .map(
      (coverageType) =>
        coverageType?.typeCode?.coverageTypeCode !== LOB.OBH &&
        Constants.COVERAGE_TYPECODE_TO_CHIP[
          coverageType?.typeCode?.coverageTypeCode || ''
        ]
    );

  const categoriesWithoutVirtualVisit =
    (enableVirtualVisitChip || enableVirtualCareEpic) && showVirtualCareCard
      ? MOCK_CARE_CATEGORIES
      : MOCK_CARE_CATEGORIES.filter(
          (chip) => chip.id !== ChipCategories.VIRTUAL_VISIT
        );

  // Step 2: Filter based on member coverage or coverageType === 'All'
  const categories = categoriesWithoutVirtualVisit.filter(
    (chip) =>
      memberCoverage.includes(chip.coverageType) || chip.coverageType === 'All'
  );

  return categories;
};
export const hasIncompleteAddress = (splitedMemberLocation: string[]) =>
  splitedMemberLocation.some((str) => str === 'null');

export const getMemberLocation = (
  member: MemberInfo,
  enableMemberDefaultLocation?: boolean
): string => {
  const addresses = member?.demographics?.address;
  if (!addresses || addresses.length === 0) {
    return '';
  }
  let permanentAddress;
  if (enableMemberDefaultLocation) {
    permanentAddress =
      addresses.find((addr) => addr.addressType === 'PERMANENT') ||
      addresses.find((addr) => addr.addressType === 'HOM');

    if (
      permanentAddress &&
      !permanentAddress.city &&
      !permanentAddress.state &&
      !permanentAddress.zipCode
    ) {
      return '';
    }
  }

  const {
    city = '',
    state = '',
    zipCode = '',
  } = permanentAddress || addresses[0];
  return `${city}, ${state} ${zipCode}`.trim();
};

export const menuItems = (memberProfiles: MemberInfo[]) => [
  {
    label: 'Subscribers:',
    model: 'active-member',
    radios: memberProfiles.map((person, index) => {
      const name = getFullName(person);

      const dob = person.demographics?.dateOfBirth || '';
      const formattedDate = dateFormatUTC(dob);
      const relationshipTypecode =
        person.demographics?.relationshipTypeCode?.code || '';

      return {
        label: name,
        value: index.toString(),
        dob: formattedDate,
        eligibility: person.eligibility,
        relationshipTypecode,
      };
    }),
  },
];
